import * as yup from "yup";

export const validationSchema = yup.object({
  contractDocument: yup
    .array()
    .min(1, "Please upload your contract document")
    .required("Please fill this required field"),
  startDate: yup.string().required("Please fill this required field"),
  endDate: yup.string().required("Please fill this required field"),
});
